<template>
  <div class="my-promotion-list">
    <!-- 垂直 -->
    <div v-if="direction == 'vertical'">
      <ul
        class="m-promotion-list"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="10"
        v-if="list.length"
      >
        <li
          v-if="type == 0"
          class="m-promotion-list-item"
          v-for="(item, index) in list"
          :key="index"
          @click="jumpTo(index)"
        >
          <!-- statsu 1进行中 2 未开始 3已结束-->
          <span
            class="m-promotion-status"
            :class="item.status | statusTagFilter"
            >{{ item.status | statusFilter }}</span
          >
          <div class="m-promotion-left">
            <img
              class="m-promotion-gallery"
              :src="item.thumbnail"
              :alt="item.title"
              :title="item.title"
            />
          </div>
          <div class="m-promotion-right">
            <span class="m-promotion-name">{{ item.title }}</span>
            <div class="m-promotion-statistics">
              <span class="m-promotion-times"
                >已拼{{ item.total_sales_counts }}件</span
              >
            </div>
            <div class="m-promotion-groupon-price">
              团购价
              <span class="m-promotion-price">
                <em>￥</em>
                {{ item.prom_price }}
              </span>
              <span class="m-promotion-discount"
                >直降￥{{ item.prom_amount }}</span
              >
            </div>
          </div>
        </li>
        <li
          v-if="type == 1"
          class="m-promotion-list-item"
          v-for="(item, index) in list"
          :key="index"
          @click="jumpTo(index)"
        >
          <!-- statsu 1进行中 2 未开始 3已结束-->
          <span
            class="m-promotion-status"
            :class="item.status | statusTagFilter"
            >{{ item.status | statusFilter }}</span
          >
          <div class="m-promotion-left">
            <img
              class="m-promotion-gallery"
              :src="item.thumbnail"
              :alt="item.title"
              :title="item.title"
            />
          </div>
          <div class="m-promotion-right">
            <span class="m-promotion-name">{{ item.title }}</span>
            <div class="m-promotion-statistics">
              <my-progress-bar :bar="item.total_sales_per" />
<!--              <span class="m-promotion-times"-->
<!--                >已售{{ item.total_sales_counts }}件</span-->
<!--              >-->
            </div>
            <div class="m-promotion-groupon-price">
              秒杀价
              <span class="m-promotion-price">
                <em>￥</em>
                {{ item.prom_price }}
              </span>
              {{ item.timeSeconds }}
              <my-countdown
                style="margin-left: auto"
                :isDayShow="true"
                :timestamp="
                  item.start_seconds > 0 ? item.start_seconds : item.end_seconds
                "
              />
            </div>
          </div>
        </li>
        <li
          v-if="type == 2"
          class="m-promotion-list-item"
          v-for="(item, index) in list"
          :key="index"
          @click="jumpTo(index)"
        >
          <!-- statsu 1进行中 2 未开始 3已结束-->
          <span
            class="m-promotion-status"
            :class="item.status | statusTagFilter"
            >{{ item.status | statusFilter }}</span
          >
          <div class="m-promotion-left">
            <img
              class="m-promotion-gallery"
              :src="item.thumbnail"
              :alt="item.title"
              :title="item.title"
            />
          </div>
          <div class="m-promotion-right">
            <span class="m-promotion-name">{{ item.title }}</span>
            <div class="m-promotion-statistics">
              <my-progress-bar :bar="item.total_sales_per" />
<!--              <span class="m-promotion-times"-->
<!--                >已售{{ item.total_sales_counts }}件</span-->
<!--              >-->
            </div>
            <div class="m-promotion-groupon-price">
              促销价
              <span class="m-promotion-price">
                <em>￥</em>
                {{ item.prom_price }}
              </span>
            </div>
          </div>
        </li>
        <li
          v-if="type == 3"
          class="m-promotion-list-item"
          v-for="(item, index) in list"
          :key="index"
          @click="jumpTo(index)"
        >
          <!-- statsu 1进行中 2 未开始 3已结束-->
          <span
            class="m-promotion-status"
            :class="item.status | statusTagFilter"
            >{{ item.status | statusFilter }}</span
          >
          <div class="m-promotion-left">
            <img
              class="m-promotion-gallery"
              :src="item.thumbnail"
              :alt="item.title"
              :title="item.title"
            />
          </div>
          <div class="m-promotion-right">
            <span class="m-promotion-name">{{ item.title }}</span>
            <div class="m-promotion-statistics">
<!--              <span class="m-promotion-times"-->
<!--                >已售{{ item.total_sales_counts }}件</span-->
<!--              >-->
            </div>
            <div class="m-promotion-groupon-price">
              组合价
              <span class="m-promotion-price">
                <em>￥</em>
                {{ item.prom_price }}
              </span>
            </div>
          </div>
        </li>
        <li
          v-if="type == 4"
          class="m-promotion-list-item"
          v-for="(item, index) in list"
          :key="index"
          @click="jumpTo(index)"
        >
          <!-- statsu 1进行中 2 未开始 3已结束-->
          <span
            class="m-promotion-status"
            :class="item.status | statusTagFilter"
            >{{ item.status | statusFilter }}</span
          >
          <div class="m-promotion-left">
            <img
              class="m-promotion-gallery"
              :src="item.thumbnail"
              :alt="item.title"
              :title="item.title"
            />
          </div>
          <div class="m-promotion-right">
            <span class="m-promotion-name">{{ item.title }}</span>
            <div class="m-promotion-statistics">
              <span class="m-promotion-delivery-times"
                >预计发货时间：2022-05-10</span
              >
<!--              <span class="m-promotion-times"-->
<!--                >已售{{ item.total_sales_counts }}件</span-->
<!--              >-->
            </div>
            <div class="m-promotion-groupon-price">
              预售价
              <span class="m-promotion-price">
                <em>￥</em>
                {{ item.prom_price }}
              </span>
            </div>
          </div>
        </li>
      </ul>
      <div class="m-promotion-empty" v-if="!list.length">
        <img :src="'cart_empty.png' | mobileImagePath" alt />
        <span>暂无活动产品</span>
      </div>
    </div>
    <div v-else>
      <ul class="m-promotion-h-list">
        <li
          class="m-promotion-h-list-item"
          v-for="(item, index) in list"
          :key="index"
          @click="jumpTo(index)"
        >
          <!-- statsu 1进行中 2 未开始 3已结束-->
          <span
            class="m-promotion-h-status"
            :class="item.status | statusTagFilter"
            >{{ item.status | statusFilter }}</span
          >
          <div class="m-promotion-h-gallery">
            <img :src="item.thumbnail" :alt="item.title" :title="item.title" />
          </div>
          <span class="m-promotion-h-title">{{ item.title }}</span>
          <div class="m-promotion-h-price">
            <div class="m-promotion-h-new-goods-price">
              <label class="m-promotion-h-label">
                {{
                  ["", "秒杀价:", "促销价:", "预售价:", "组合价:", "团购价:"][
                    item.type
                  ]
                }}
              </label>
              <span
                class="m-promotion-h-goods-new-price"
                :style="item.type == 1 ? 'display;block' : ''"
                ><em>￥ </em>{{ item.prom_price }}</span
              >
            </div>
            <del class="m-promotion-h-old-goods-price">
              <span :style="item.type == 1 ? 'display;block' : ''"
                ><em>￥ </em>{{ item.price }}</span
              >
            </del>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import MyProgressBar from "@/pages/mobile/components/MyProgressBar";
import MyCountdown from "@/pages/mobile/components/MyCountdown";
export default {
  name: "MyPromotionList",
  components: { MyProgressBar, MyCountdown },
  data() {
    return {
      loading: false,
    };
  },
  filters: {
    statusTagFilter(status) {
      const map = {
        1: "red",
        2: "gray_red",
        3: "gray",
      };
      return map[status];
    },
    statusFilter(status) {
      const map = {
        1: "进行中",
        2: "未开始",
        3: "已结束",
      };
      return map[status];
    },
  },
  props: {
    list: [],
    type: 0,
    direction: {
      type: String,
      default: "vertical",
    },
  },
  methods: {
    loadMore() {},
    jumpTo(index) {
      const { list } = this;
      const { activity_id } = list[index];
      this.$router.push({ path: "mpromotionDetail", query: { activity_id } });
    },
  },
  created() {},
};
</script>
<style scoped>
.m-promotion-list {
  overflow: hidden;
}

.m-promotion-list-item {
  background: #fff;
  width: 90%;
  margin: auto;
  margin-top: 0.2rem;
  border-radius: 0.2rem;
  padding: 0.2rem;
}

.m-promotion-list-item img {
  width: 2rem;
  height: 2rem;
  display: block;
}

.m-promotion-list-item .m-promotion-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.m-promotion-price {
  color: #f00;
  font-weight: bold;
}

.m-promotion-gallery {
  width: 100%;
  border: 1px solid #efefef;
  border-radius: 0.2rem;
}

.m-promotion-groupon-price {
  margin-top: 0.2rem;
  display: flex;
  align-items: center;
}

.m-promotion-list-item {
  display: flex;
  align-items: center;
  position: relative;
}

.m-promotion-right {
  margin-left: 0.2rem;
  width: 100%;
}

.m-promotion-times {
  display: block;
  color: #9a9a99;
}

.m-promotion-discount {
  color: #f00;
  border: 1px solid #f00;
  border-radius: 0.5rem;
  padding: 0 0.2rem;
  margin-left: 0.2rem;
}

.m-promotion-groupon-price {
  color: #f00;
}

.m-promotion-status {
  position: absolute;
  top: 0;
  color: #fff;
  padding: 0.1rem 0.2rem;
  left: 0.2rem;
  border-bottom-left-radius: 0.1rem;
  border-bottom-right-radius: 0.1rem;
}

.m-promotion-status.red {
  background: #f00;
}

.m-promotion-status.gray_red {
  background: #fbc5c5;
}

.m-promotion-status.gray {
  background: #989898;
}

.m-promotion-statistics {
  margin-top: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.m-promotion-empty {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background: #fff;
  padding: 0.6rem 0;
  min-height: 10rem;
}

.m-promotion-empty span {
  margin: 0.4rem 0;
}

.m-promotion-empty img {
  width: 3rem;
}

.m-promotion-h-list-item {
  background: #fff;
  width: 50%;
  padding: 0.2rem;
  float: left;
  position: relative;
}

.m-promotion-h-list-item img {
  width: 100%;
  height: 100%;
  display: block;
}

.m-promotion-h-list {
  overflow: hidden;
  overflow-x: scroll;
  /* display: flex; */
}
.m-promotion-h-status {
  position: absolute;
  top: 0.2rem;
  color: #fff;
  padding: 0.1rem 0.2rem;
  left: 0.2rem;
  border-bottom-left-radius: 0.1rem;
  border-bottom-right-radius: 0.1rem;
}

.m-promotion-h-status.red {
  background: #f00;
}

.m-promotion-h-status.gray_red {
  background: #fbc5c5;
}

.m-promotion-h-status.gray {
  background: #989898;
}
.m-promotion-h-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 0.2rem;
  font-weight: bold;
  font-size: 0.24rem;
  height: 0.6rem;
}
.m-promotion-h-new-goods-price {
  display: flex;
  color: #ff0000;
  margin-right: 0.2rem;
}
.m-promotion-h-price{
  display: flex;
  margin-top: 0.2rem;
}
.m-promotion-h-gallery{
  border-radius: 0.2rem;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/mobile/components/MyPromotionList/index.vue